import { render } from "./Fusion_Details.vue?vue&type=template&id=830470da"
import script from "./Fusion_Details.vue?vue&type=script&lang=js"
export * from "./Fusion_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__